module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/twitter_page2.e3270431.jpg";